module.exports = __webpack_public_path__ + "img/u83.ed2fca2f.svg";